module.exports = __webpack_public_path__ + "img/ALittleObsessed.bd7accc1.jpeg";